import React from "react";
import { useRecoilState } from "recoil";

import { Dialog } from "primereact/dialog";

import { projectSwitchDialogAtom } from "../../atoms/DialogAtom";

function ProjectSwitchDialog(props) {
	const { header, footer } = props;
	const appElement = document.getElementById("appWrapper");

	const [show, setShow] = useRecoilState(projectSwitchDialogAtom);

	return (
		<Dialog header={header} footer={footer} visible={show} closable={true} onHide={() => setShow(false)} appendTo={appElement} maskClassName="mask">
			{props.children}
		</Dialog>
	);
}

export default ProjectSwitchDialog;
